import { PlatformCheckbox } from "./PlatformCheckbox";

export default PlatformCheckbox;
